import React from 'react';
import { NewDownload } from '@plataforma/components/src/components/Icons';
import { ManualUrlCancellationWithRefund } from '@plataforma/utils/src/constants/constants';
import {
  Container,
  Details,
  Tag,
  Description,
  Button,
  BannerImage
} from './styles';

const CancellationWithRefund = () => {
  function handleDonwload() {
    const url = ManualUrlCancellationWithRefund;

    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.target = '_blank';
    anchorElement.download = url;
    anchorElement.click();
  }

  return (
    <Container data-testid="cancellation-with-refund-banner">
      <Details>
        <Tag>Novidade</Tag>
        <Description>
          <>O cancelamento </>
          <span>com restituição </span>
          <>já pode ser emitido direto na Plataforma!</>
        </Description>
        <Button onClick={() => handleDonwload()}>
          <NewDownload />
          <Button>Ver detalhes</Button>
        </Button>
      </Details>
      <BannerImage>
        <img
          src="https://static.juntoseguros.com/images/person.svg"
          alt="person"
        />
      </BannerImage>
    </Container>
  );
};

export default CancellationWithRefund;
